module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--5.fa40d272.svg";